/**
 * Resolves and normalizes image URLs across Local, Staging, and Production environments.
 * Specifically fixes staging issue where uploads are stored on `hrmsstagingapi.cherrypiksoftware.com`
 * but URLs generated or stored in the database contain `hrmsstaging.cherrypiksoftware.com` or relative `/uploads/`.
 */
export const resolveImageUrl = (url) => {
  if (!url || typeof url !== "string") return "";
  const trimmedUrl = url.trim();
  if (!trimmedUrl) return "";

  // 1. If URL has frontend staging host with /uploads/, point to staging API host
  if (trimmedUrl.includes("hrmsstaging.cherrypiksoftware.com/uploads/")) {
    return trimmedUrl.replace(
      /https?:\/\/hrmsstaging\.cherrypiksoftware\.com\/uploads\//i,
      "https://hrmsstagingapi.cherrypiksoftware.com/uploads/"
    );
  }

  // 2. If URL has production frontend host with /uploads/, point to production API host
  if (trimmedUrl.includes("hrms.cherrypiksoftware.com/uploads/")) {
    return trimmedUrl.replace(
      /https?:\/\/hrms\.cherrypiksoftware\.com\/uploads\//i,
      "https://hrmsapi.cherrypiksoftware.com/uploads/"
    );
  }

  // 3. If URL is a relative path starting with "/uploads/" or "uploads/"
  if (trimmedUrl.startsWith("/uploads/") || trimmedUrl.startsWith("uploads/")) {
    const cleanPath = trimmedUrl.startsWith("/") ? trimmedUrl : `/${trimmedUrl}`;
    const hostname =
      typeof window !== "undefined" ? String(window.location.hostname || "").toLowerCase() : "";

    if (hostname === "hrmsstaging.cherrypiksoftware.com") {
      return `https://hrmsstagingapi.cherrypiksoftware.com${cleanPath}`;
    }
    if (hostname === "hrms.cherrypiksoftware.com") {
      return `https://hrmsapi.cherrypiksoftware.com${cleanPath}`;
    }
    if (
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname.endsWith(".localhost.com")
    ) {
      return `http://cspi-ems-api.localhost.com${cleanPath}`;
    }
    return cleanPath;
  }

  // 4. Upgrade http to https on staging/production to avoid mixed content blocking
  if (trimmedUrl.startsWith("http://hrmsstagingapi.cherrypiksoftware.com")) {
    return trimmedUrl.replace("http://", "https://");
  }
  if (trimmedUrl.startsWith("http://hrmsapi.cherrypiksoftware.com")) {
    return trimmedUrl.replace("http://", "https://");
  }

  return trimmedUrl;
};

export default resolveImageUrl;
